import { MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  Divider,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';

import { IcArrowDown, ICCareLinkLogo } from '@/assets/images';
import { Avatar, PageHeader } from '@/components';
import { withLoader, WithLoaderProps } from '@/hocs';

import { cfs } from '../data';

const CFSHeader = ({
  isQuickView,
}: {
  cfsId?: string;
  isQuickView?: boolean;
} & WithLoaderProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openActionsMenu = Boolean(anchorEl);

  const navigate = useNavigate();

  const handleCloseCFS = () => {
    handleCloseActionsMenu();
  };

  const handleOpenActionsMenu = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUpdatePrimaryOfficer = () => {
    setAnchorEl(null);
  };

  const handleCloseActionsMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PageHeader
        onBack={
          isQuickView
            ? () => {
                navigate('/cfs-active');
                localStorage.removeItem('cfs-back-route');
              }
            : undefined
        }
        backRoute={undefined}
      >
        <Stack flex={1} direction="row" alignItems="center" columnGap={2.5}>
          <Button
            variant="contained"
            color="error"
            onClick={handleOpenActionsMenu}
            endIcon={<IcArrowDown />}
            className="cfs-action-button"
          >
            Actions
          </Button>

          <Typography variant="inherit" sx={{ fontSize: '1.313rem' }}>
            {cfs.number}
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" columnGap={2.5}>
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              backgroundColor: 'white',
              border: '1px solid',
              padding: '4px 8px',
              borderColor: 'secondary.200',
              borderRadius: '8px',
            }}
          >
            <ICCareLinkLogo />
            <Typography fontSize={15} fontWeight={500} paddingLeft={1}>
              Initiated by CareLink
            </Typography>
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Avatar className="cfs-detail-avatar" name="D S" showTooltip />
        </Stack>
      </PageHeader>

      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={openActionsMenu}
        onClose={handleCloseActionsMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <>
          <MenuItem onClick={handleUpdatePrimaryOfficer}>
            Update primary officer
          </MenuItem>
          <MenuItem onClick={handleCloseCFS}>Close CFS record</MenuItem>
        </>
      </Menu>
    </>
  );
};

export default withLoader(CFSHeader);
